module.exports = __webpack_public_path__ + "media/images/zamani-2596da90036cf339f6183d1c9dd45a09.png";